<template>
  <div class="participation-term-enel" v-if="!loading" style="margin: 0.1cm;">
    <div class="row">
      <div class="col-xs-3">
        <img src="/static/img/enel-compartilha-logo.gif" class="img-responsive">
      </div>
      <div class="col-xs-6 text-center"><h3>Termo Comodato</h3></div>
      <div class="col-xs-3"></div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p>
          A {{ company }}, pessoa jurídica de direito privado, com sede em {{ address }}, inscrita no CNPJ sob o no. {{ cpnj }} e Inscrição Estadual no. {{ stateRegistration }}, doravante denominada {{ shortname }}, e o(a) <span style="text-transform: capitalize;">{{ ticket.customer.holder }}</span>, residente e domiciliado(a) na {{ ticket.customer.address.street }}, {{ ticket.customer.address.number }}, {{ ticket.customer.address.complement }} - {{ ticket.customer.address.neighborhood }} - {{ ticket.customer.address.zip }}, na cidade de {{ ticket.customer.address.city }}, Ceará, UC n.o {{ ticket.customer.uc }}, CPF n.o {{ ticket.customer.cpf }}, firmam o presente TERMO DE COMODATO, cujas condições, declarações e compromissos assumidos e acordados encontram-se descritos a seguir:
        </p>

        <h5>CLÁUSULA PRIMEIRA – DAS CONSIDERAÇÕES PRELIMINARES</h5>
        <ol>
          <li>
            Você esta participando do projeto Enel Compartilha Eficiência. O programa prevê a substituição da sua geladeira antiga, com maior consumo de energia, por uma nova geladeira com selo PROCEL A de economia de energia, Caso V.S. seja contemplado (a) dentro dos critérios elegíveis e esta de posse dos seguintes documentos CPF, RG, CONTA DE ENERGIA PAGAS EM DIAS e RECEBER ALGUM BENEFICIO DO GOVERNO FEDERAL como BOLSA FAMÍLIA;
          </li>
          <li>
            A ENEL está desenvolvendo o "Enel Compartilha Eficiência" que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia elétrica e orientações na resolução dos problemas sociais nas comunidades;
          </li>
          <li>
            No tocante às práticas relacionadas quanto ao uso racional de energia elétrica, enquadra-se como tal, entre outras, a substituição de geladeiras;
          </li>
          <li>
            A ENEL buscando viabilizar essa prática nas comunidades atendidas pelo "Enel Compartilha Eficiência", entre outras ações, realizará a substituição de geladeiras nas unidades consumidoras atendidas, nas condições relacionadas na cláusula segunda deste instrumento;
          </li>
        </ol>


        <h5>CLÁUSULA SEGUNDA – DAS CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO</h5>
        <ol>
          <li>
            Para ter o beneficio da geladeira é necessária à autorização do titular da conta permitindo a realização de medições nas geladeiras antes e após a troca com objetivo de determinar o percentual de economia;
          </li>
          <li>
            A ENEL substituirá geladeiras das unidades consumidoras atendidas pelo projeto, sendo 01 (uma) geladeira por unidade consumidora beneficiada, desde que atendam aos critérios da ENEL;
          </li>
          <li>
            A geladeira entregue pela ENEL ao consumidor será realizada através de comodato, o qual perdurará pelo período de 24 (vinte e quatro) meses, contados do recebimento da mesma;
          </li>
          <li>
            Ao serem entregues a novas geladeiras pela ENEL, o consumidor se obriga e entregar aquela que se encontra funcionando em sua residência, passando esta a ser de propriedade da <strong>3E Engenharia em Eficiência Energética</strong>;
          </li>
          <li>
            Após o término do prazo determinado no item 2.3 desta cláusula, a geladeira entregue pela ENEL em comodato, passa a ser de propriedade do consumidor;
          </li>
          <li>
            O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o parcelamento firmado com a ENEL;
          </li>
        </ol>

        <h5>CLÁUSULA TERCEIRA – DAS OBRIGAÇÕES DO CONSUMIDOR</h5>
        <ol>
          <li>
            Se V.S. seja contemplado (a), será permitida a retirada da geladeira nova somente no dia {{ datetimeDelivery }}{{ timeEndDelivery }};
          </li>
          <li>
            Perderá o beneficio, caso seja contemplado, se não comparecer no dia {{ datetimeDelivery }}{{ timeEndDelivery }} com a sua geladeira antiga em funcionamento;
          </li>
          <li>
            Caso o contemplado não compareça, haverá uma substituição do seu benefício para outro cliente cadastrado que fica em uma fila de espera criada pela equipe;
          </li>
          <li>
            É de responsabilidade do contemplado o transporte da geladeira antiga até o local da troca informado pela equipe, como também o transporte de sua geladeira nova;
          </li>
          <li>
            O contemplado se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação semelhante) a geladeira recebida. Em caso de descumprimento, terá todos os benefícios oriundos do "Projeto ENEL Comunidades" cancelados, sendo a geladeira objeto do comodato em referência, recolhido imediatamente pela ENEL;
          </li>
          <li>
            O contemplado desde já, autoriza a qualquer momento, a inspeção pelos funcionários da ENEL, para verificação do estado do sistema elétrico da residência e da geladeira objeto do presente comodato, e, em caso de constatação de irregularidade, o contemplado terá todos os benefícios oriundos do "ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA" cancelados;
          </li>
        </ol>

        <p>
          <span class="captalize">{{ ticket.customer.address.city }}</span>, {{ new Date | moment('LLL') }}
        </p>
      </div>
    </div>

    <signature-customer-ticket :customer="ticket.customer" />

    <table>
      <thead>
        <th>CONF</th> <th>EGV</th> <th>DOC</th> <th>EGN</th>
      </thead>
      <tbody>
        <tr>
          <td></td> <td></td> <td></td> <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import SignatureCustomerTicket from '../../SignatureCustomerTicket'

export default {
  name: 'ParticipationTermEnel',
  components: {
    SignatureCustomerTicket
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      company: 'Companhia Energética do Ceará - ENEL',
      shortname: 'ENEL',
      address: 'Rua Padre Valdevino, nº 150 – Centro, Fortaleza/CE',
      cpnj: '07.047.251/0001-70',
      stateRegistration: '06.105.848-3',
      projectName: 'ENEL COMPARTILHA EFICIÊNCIA DE GELADEIRA DO PROJETO DE EFICIÊNCIA ENERGÉTICA'
    }
  },
  computed: {
    datetimeDelivery () {
      return this.ticket.event.hasOwnProperty('dateTimeDelivery') && this.ticket.event.dateTimeDelivery !== '' ? this.$moment(
        this.ticket.event.dateTimeDelivery).format('LLL') : 'e horário definidos pela equipe'
    },

    timeEndDelivery () {
      return this.ticket.event.hasOwnProperty('timeEndDelivery') && this.ticket.event.timeEndDelivery !== '' ? ' até as ' + this.ticket.event.timeEndDelivery : ', com tolerância de 1 horas'
    }
  },
  filters: {
    uppercase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    }
  }
}
</script>
<style scoped>
  .uppercase {
    text-transform: uppercase;
  }

  .captalize {
    text-transform: capitalize;
  }

  p, li {
    font-size: 8pt;
  }

  p {
    text-align: justify;
  }
  table {
    border-spacing: 0.5rem;
    width: 100%;
  }

  td, th {
    text-align: center;
    border: 1px solid #999;
    padding: 0.5rem;
  }

  th {
    background-color: #ddd;
  }

  td {
    padding-bottom: 4em;
    width: 25%;
  }

  .sign-line {
    border-bottom: 2px solid #000;
    margin-bottom: 10px;
    margin-top: 60px;
  }

  @page {
    size: auto;   /* auto is the current printer page size */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/EnelCe/ParticipationTermEnelCe.vue